import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@material-ui/icons/Delete";
import { colors, IconButton } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
        minHeight:400

    },
}));

export default function SafesTransferTables(props) {
    const { paramsSubList, 
        rptParams,
        valueAutosSub,
        setValueAutosSub,
        unitsOptions, setParamsSubList,estelamAfter,selectRow,handOSnack
    } = props;


    const stylH = {
        // borderWidth: 1,
        border: "solid 0.6px",
        borderColor: "black",
        borderStyle: "solid",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 16,
        color: "#fff"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        //borderStyle: "solid",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 15,
        color: "#000"
    }
    const onRowDelete =async (rowdata) => {
        if(estelamAfter){
           // alert("لا يمكن حذف الصنف من قائمة التحويل لارتباطه ب امر استلام...برجاء حذف الاستلام اولا");
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text:"لا يمكن حذف الصنف من قائمة التحويل لارتباطه ب امر استلام...برجاء حذف الاستلام اولا",
                time: 2000,
              });
        }else{
            var newData = paramsSubList.filter((obj) => obj.barcode.toString() !== rowdata.barcode.toString());  
            setParamsSubList([...newData]);
        }
    }
    const onRowClick =async (rowdata) => {
        if(estelamAfter){
           // alert("لا يمكن تعديل الصنف في قائمة التحويل لارتباطه ب امر استلام...برجاء حذف الاستلام اولا");
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text:"لا يمكن تعديل الصنف في قائمة التحويل لارتباطه ب امر استلام...برجاء حذف الاستلام اولا",
                time: 2000,
              });
        }else{
          selectRow(rowdata);
        }
    }
    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    const data = paramsSubList.map((row,i) => {
        return {
          ...row,
         id: i,
        };
      });
     
    useEffect(() => {
        // console.log("units is", currUnitList)
    }, [paramsSubList]);

    return (
        <TableContainer component={Paper} >
            <Table
                //className={classes.table} 
                size="small" aria-label="a dense table" >
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor: "#3f51b5" ,
                            color: "#000",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 17,
                            border: "solid 0.6px"
                        }}
                    >
                        <TableCell  style={stylH} hidden={true} align="center">
                            {t("number")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("barcode")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("item")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("unit")}
                        </TableCell>
                        
                        <TableCell style={stylH} align="center">
                            {t("quanity")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"الكمية الاجمالية"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("quantity-available")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("unit-balance")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("price")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("total")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"Action"}
                        </TableCell>
                       
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row) => (
                        <TableRow key={row.barcode}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                fontWeight: 800,
                                fontFamily: "Amiri-Regular",
                                fontSize: 17,
                                border: "solid 0.6px"
                            }}>
                            <TableCell style={stylRo}  align="center" onClick={() => { onRowClick(row); }}>{row.currency}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.barcode}</TableCell>

                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.symbol}</TableCell>

                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.unitName}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.val1}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.value}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.qty_balance}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.unit_balance}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.price}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.total}</TableCell>
                            <TableCell style={stylRo} align="center" >
                            <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    style={{ maxHeight: "0.7rem" }}
                                    // onClick={onDelete}

                                onClick={() => {
                                    onRowDelete(row);
                                }}>
                                
                                    <DeleteIcon size={"small"} />
                                </IconButton>
                            </TableCell>

                        </TableRow>
                    ))}
                </TableBody>

            </Table>
            
        </TableContainer>
        
    );
}
